<template>
  <div
    class="mockup-preview-zoom"
    :style="styleMockupPreviewZoom"
    @click="imageIndex++"
  >
    <mockup-preview-dynamic-render
      v-if="available"
      :scale="scale"
      :width="previewWidth"
      :height="previewHeight"
      :preview="current"
      :timestamp="10000"
      :color="null"
      @load="(e) => $emit('load', e)"
    >
      <template v-slot:canvas="{ previewContext }">
        <img
          :width="previewContext.width"
          :height="previewContext.height"
          :src="stamp"
          style="position: absolute; top: 0; left: 0;"
        />
      </template>
    </mockup-preview-dynamic-render>
    <div v-else class="mockup-preview-zoom__render" :style="style"></div>

    <div class="mockup-preview-zoom__options">
      <div class="mockup__input" style="font-size: 10px;">
        <div
          class="mockup__btn"
          v-for="(p, i) in presets"
          :key="i"
          @click="setPreset(i)"
          v-show="p === preset"
        >
          {{ p.name }}
        </div>
      </div>
      <div class="mockup__input" style="font-size: 10px;">
        <div class="mockup__btn" @click="setBottle360">
          360°
        </div>
      </div>
      <div class="mockup__input">
        <label for="">Zoom: {{ current.scale }}</label>
        <input
          type="range"
          v-model.number="current.scale"
          step="0.01"
          min="0"
          max="5"
        />
      </div>
      <div class="mockup__input">
        <label for="">X: {{ current.translateX }}</label>
        <input
          type="range"
          v-model.number="current.translateX"
          step="0.01"
          min="-1"
          max="1"
        />
      </div>
      <div class="mockup__input">
        <label for="">Y: {{ current.translateY }}</label>
        <input
          type="range"
          v-model.number="current.translateY"
          step="0.01"
          min="-1"
          max="1"
        />
      </div>
      <div class="mockup__input">
        <label for="">positionX: {{ current.positionX }}</label>
        <input
          type="range"
          v-model.number="current.positionX"
          step="1"
          :min="-this.previewContext.width"
          :max="this.previewContext.width / 2"
        />
      </div>
      <div class="mockup__input">
        <label for="">positionY: {{ current.positionY }}</label>
        <input
          type="range"
          v-model.number="current.positionY"
          step="1"
          :min="-this.previewContext.width"
          :max="this.previewContext.width / 2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MockupPreviewDynamicRender from "@gocasebr/go-shared/dist/mockup-preview-dynamic-render/MockupPreviewDynamicRender";
var SCALE_HEIGHT = window.innerWidth * 0.5 - 32;

export default {
  components: { MockupPreviewDynamicRender },
  props: {
    current: Object,
  },
  data() {
    return {
      previewWidth: null,
      previewHeight: null,
      scale: null,
      presets: require("./preset.json"),
      iPreset: null,
      imageIndex: 0,
      stampImages: [
        "https://custom-case-images.s3.amazonaws.com/prisma-render/prod-v2/catalog-front/514032028557394317200149818972686645690523044.png",
        "https://custom-case-images.s3.amazonaws.com/prisma-render/prod-v2/catalog-front/poeira-das-estrelas-manuscrita/caseimpactslimstandard-iphone11/22884461836535874171995954923803599297098410603.png",
      ],
      stampFor360: null,
    };
  },
  computed: {
    stamp() {
      return (
        this.stampFor360 ||
        this.stampImages[this.imageIndex % this.stampImages.length]
      );
    },
    available() {
      return (
        !!this.previewWidth &&
        !!this.previewHeight &&
        this.current.previewColors?.find((el) => el)?.src
      );
    },
    image() {
      const { current } = this;
      switch (current.jsClass) {
        case "MockupPreviewDynamicModel":
          return (
            current.previewColors?.find((el) => el)?.src ||
            current.previewMask?.src
          );
        case "MockupPreviewImageModel":
          return current.previewImage.src;
        case "MockupPreviewVideoModel":
          return null;
        default:
          return null;
      }
    },
    previewContext() {
      return {
        width: this.previewWidth * this.scale * this.current.scale,
        height: this.previewHeight * this.scale * this.current.scale,
      };
    },
    styleMockupPreviewZoom() {
      const { previewWidth, previewHeight, scale } = this;
      const max = previewWidth > previewHeight ? previewWidth : previewHeight;
      return {
        width: `${max * scale}px`,
        height: `${max * scale}px`,
      };
    },
    style() {
      const { translateX, translateY } = this.current;
      const { width, height } = this.previewContext;
      const { image } = this;
      if (!image) return;
      const transform = `translate(${100 * translateX}%, ${100 * translateY}%)`;
      return {
        transform,
        "-o-transform": transform,
        "-ms-transform": transform,
        "-moz-transform": transform,
        "-webkit-transform": transform,
        width: `${width}px`,
        height: `${height}px`,
        backgroundImage: `url(${image})`,
      };
    },
    preset() {
      const { scale, translateX, translateY } = this.current;
      return (
        this.presets.find(
          (p) =>
            p.scale === scale &&
            p.translateX === translateX &&
            p.translateY === translateY
        ) || this.presets.find((p) => !!p)
      );
    },
  },
  watch: {
    current: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      if (!this.image) return;

      const img = new Image();
      img.onload = () => {
        this.previewWidth = img.width;
        this.previewHeight = img.height;
        this.scale = SCALE_HEIGHT / this.previewHeight;
      };
      img.src = this.image;
    },
    setBottle360() {
      this.current.stampX2 = this.current.stampX1 + this.previewContext.width;
      this.current.stampX4 = this.current.stampX1 + this.previewContext.width;
      this.current.stampX3 = this.current.stampX1;
      // this.current.stampX2 = this.current.stampX1 + this.previewContext.width
      this.stampFor360 = !this.stampFor360
        ? "https://i.imgur.com/ltVZulI.png"
        : null;
    },
    setPreset(i) {
      if (!this.iPreset) this.iPreset = i;
      this.iPreset++;

      const preset = this.presets.find(
        (p, ii) => ii === this.iPreset % this.presets.length
      );
      this.current.scale = preset.scale;
      this.current.translateX = preset.translateX;
      this.current.translateY = preset.translateY;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-zoom {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: cornflowerblue;
  overflow: hidden;
  flex: none;
  border-radius: 5px;

  .mockup-preview-zoom__render {
    position: absolute;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }

  .mockup-preview-zoom__options {
    position: absolute;
    z-index: 1;
    background-color: rgba($color: #fff, $alpha: 0.5);
    border-radius: 0 5px 0 0;
    padding: 6px;
    bottom: 0;
    left: 0;
    width: 30%;
  }
}
</style>
